"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for rows of Promotion performance reports.
 */


var PromotionPerformanceReportRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionPerformanceReportRowDTOConverter, _DataObjectConverter_);

  function PromotionPerformanceReportRowDTOConverter() {
    _classCallCheck(this, PromotionPerformanceReportRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportRowDTOConverter).apply(this, arguments));
  }

  return PromotionPerformanceReportRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionPerformanceReportRowDTOConverter = PromotionPerformanceReportRowDTOConverter;